export type CheckoutPaymentProvider = 'invoier' | 'two' | 'stripe';

const CHECKOUT_PAYMENT_PROVIDERS: CheckoutPaymentProvider[] = ['invoier', 'two', 'stripe'];

export function normalizePaymentProvider(
    provider: string | null | undefined
): CheckoutPaymentProvider | null {
    const normalized = (provider ?? '').toLowerCase().trim();
    return CHECKOUT_PAYMENT_PROVIDERS.find((known) => known === normalized) ?? null;
}

const PROVIDER_LABEL_KEYS: Record<CheckoutPaymentProvider, string> = {
    invoier: 'financier1',
    two: 'financier2',
    stripe: 'financier3'
};

/** Off production (staging demos) customers must never see the provider's real name, only these neutral labels. */
export function paymentProviderLabelKey(provider: CheckoutPaymentProvider): string {
    return PROVIDER_LABEL_KEYS[provider];
}

export function isProductionApi(apiBaseUrl: string | undefined): boolean {
    return apiBaseUrl === 'https://app.dicopay.com/';
}

export type PaymentProviderFooterContent =
    | { kind: 'logo'; provider: 'invoier' | 'two' }
    | { kind: 'label'; labelKey: string };

/** Production shows the real financier; the names are hidden only for demos on staging. */
export function paymentProviderFooterContent(
    provider: CheckoutPaymentProvider,
    production: boolean
): PaymentProviderFooterContent {
    if (!production) {
        return { kind: 'label', labelKey: paymentProviderLabelKey(provider) };
    }
    if (provider === 'stripe') {
        return { kind: 'label', labelKey: `${paymentProviderLabelKey(provider)}_production` };
    }
    return { kind: 'logo', provider };
}

/**
 * FAST-financing providers whose customer approves the invoice on this page.
 * Stripe then takes the customer to its own hosted payment page and back.
 */
export function usesInvoierCheckout(provider: string | null | undefined): boolean {
    return normalizePaymentProvider(provider) != null;
}

export function shouldShowPaymentProviderFooter(
    invoiceType: string,
    provider: string | null | undefined
): boolean {
    return invoiceType === 'fast' && normalizePaymentProvider(provider) != null;
}
